import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroComponent } from './components/hero/hero.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MenuItemFormComponent } from './components/menu-item-form/menu-item-form.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ActivateAccountComponent } from './components/activate-account/activate-account.component';
import { ModalComponent } from '@adminprodigydesign/axis';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';
import { RestaurantHeaderComponent } from './components/restaurant-header/restaurant-header.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { WaitronPageLoaderComponent } from './components/waitron-page-loader/waitron-page-loader.component';
import { RestaurantInfoModalComponent } from './dialogs/restaurant-info-modal/restaurant-info-modal.component';

@NgModule({
  declarations: [
    HeroComponent,
    MenuItemFormComponent,
    ActivateAccountComponent,
    CookieBannerComponent,
    RestaurantHeaderComponent,
    OrderSummaryComponent,
    WaitronPageLoaderComponent,
    RestaurantInfoModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MatDialogModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    ModalComponent,
  ],
  exports: [
    HeroComponent,
    FontAwesomeModule,
    MenuItemFormComponent,
    CookieBannerComponent,
    RestaurantHeaderComponent,
    OrderSummaryComponent,
    WaitronPageLoaderComponent,
    RestaurantInfoModalComponent,
  ],
})
export class SharedModule {}
